/* Parans About — Value & Video: swap poster for the real video on click */
(function () {
  function initVideo(wrap) {
    var poster = wrap.querySelector('.parans-about-value__video-poster');
    var btn = wrap.querySelector('.parans-about-value__play');
    var tmpl = wrap.querySelector('[data-parans-video-embed]');
    if (!poster || !btn || !tmpl) return;

    btn.addEventListener('click', function () {
      var frag = tmpl.content ? tmpl.content.cloneNode(true) : null;
      if (!frag) return;
      poster.innerHTML = '';
      poster.appendChild(frag);
      wrap.classList.add('is-playing');

      var media = poster.querySelector('video, iframe');
      if (media && typeof media.play === 'function') {
        try { media.play(); } catch (e) {}
      }
    });
  }

  function init() {
    var wraps = document.querySelectorAll('[data-parans-video]');
    for (var i = 0; i < wraps.length; i++) initVideo(wraps[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
